import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';
import { Zap } from 'lucide-react';

export default function QuizHeader({ currentStep, totalSteps, progress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Zap className="w-6 h-6 text-primary" />
          <span className="text-xl font-light text-primary" style={{ fontFamily: 'Outfit' }}>{t('nav.brand')}</span>
        </div>
        <button onClick={() => navigate('/')} className="text-sm text-muted-foreground hover:text-primary">{t('quiz.exitQuiz')}</button>
      </div>
      <Progress value={progress} className="h-2" data-testid="quiz-progress" />
      <p className="text-sm text-muted-foreground mt-2">{t('quiz.step', { current: currentStep, total: totalSteps })}</p>
    </div>
  );
}
